import { ReportType } from '../schemas/report.schemas';

export function getReportUniqueBusinessKey(report: ReportType): string {
    return `${report.year}/${report.period}/${report.type}/${report.reportType}`;
}

export function getNumberOfDecimals(number: number) {
    let result = 0;
    if (Math.floor(number) !== number) {
        result = number.toString().split('.')[1].length;
    }
    return result
}
